import { Box, Card, CardContent, Typography } from "@mui/material";
import { LineChart } from "@mui/x-charts";
import { formatShortNumber } from "../../utils/DateTool";
import { dashboardCardSx } from "../layout/dashboardStyles";

interface MetricCardProps {
  title: string;
  value: string | number;
  sub: string;
  data: number[];
  color: string;
  areaColor: string;
  percent: number;
}

export const MetricCardHorizontal: React.FC<MetricCardProps> = ({
  title,
  value,
  sub,
  data,
  color,
  areaColor,
  percent,
}) => (
  <Card
    sx={{
      ...dashboardCardSx,
      width: "100%",
      minWidth: 0,
      height: { xs: "auto", sm: 160 },
      position: "relative",
      overflow: "visible",
    }}
  >
    <Box sx={{ position: "absolute", top: 16, right: 16 }}>
      {/* <Box
        sx={{
          bgcolor: percent > 0 ? "success.main" : "error.main",
          color: "#fff",
          px: 1.5,
          py: 0.5,
          display: "inline-block",
          borderRadius: 3,
          fontSize: "0.85rem",
          fontWeight: 600,
          boxShadow: "0 1px 6px #0002",
        }}
      >
        {percent > 0 ? "+" : ""}
        {percent}%
      </Box> */}
    </Box>
    <CardContent sx={{ p: { xs: 1.5, sm: 2 } }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
        {title}
      </Typography>
      <Typography variant="h4" sx={{ fontWeight: 800 }}>
        {formatShortNumber(value)}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {sub}
      </Typography>
      <Box sx={{ mt: 1, width: "100%", height: { xs: 56, sm: 70 } }}>
        <LineChart
          height={50}
          series={[
            {
              data,
              color,
              showMark: false,
              area: true,
              // areaColor,
              curve: "monotoneX",
            },
          ]}
          xAxis={[
            {
              data: data.map((_, i) => i),
              scaleType: "band",
            },
          ]}
          yAxis={[{}]}
          grid={{ horizontal: false, vertical: false }}
          margin={{ top: 6, bottom: 24, left: 0, right: 0 }}
          sx={{
            ".MuiChartsAxis-root": { display: "none" },
            ".MuiChartsAxis-tick": { display: "none" },
            ".MuiChartsAxis-line": { display: "none" },
            ".MuiChartsAxis-label": { display: "none" },
            ".MuiChartsAxis-tickLabel": { display: "none" },
            ".MuiLineElement-root": { strokeWidth: 2, filter: "blur(0.2px)" },
            ".MuiAreaElement-root": {
              opacity: 1,
              fill: areaColor,
            },
          }}
        />
      </Box>
    </CardContent>
  </Card>
);
